import React from 'react'

import { DropdownOption as UIDropdownOption } from '@carsys/ui'

type UIRadioOptionProps = React.ComponentProps<typeof UIDropdownOption>

interface DropdownOption extends Omit<UIRadioOptionProps, 'value'> {
  value: any
}

export const DropdownOption = React.forwardRef<HTMLLIElement, DropdownOption>((props, ref) => {
  return <UIDropdownOption {...props} ref={ref} />
})
